import type { ReactNode } from "react";
import { GripVertical } from "lucide-react";
import type { Account } from "../../types";
import type { useAccountOrder } from "./use-account-order";

export default function AccountOrderCard({ account, group, siblings, order, children }: {
  account: Account;
  group: string;
  siblings: Account[];
  order: ReturnType<typeof useAccountOrder>;
  children: ReactNode;
}) {
  return (
    <div className="account-order-card" style={{ position: "relative", minWidth: 0,
      opacity: order.dragging === account.id ? .55 : undefined,
      outline: order.target === account.id && order.dragging !== account.id ? "2px solid var(--mint)" : undefined }}
      data-order-id={account.id} data-order-group={group}>
      {children}
      {siblings.length > 1 && <button type="button" className="icon-button account-drag-handle"
        style={{ position: "absolute", right: 5, top: 7, touchAction: "none", userSelect: "none", cursor: "grab" }}
        aria-label={`Reorder ${account.name}`} title="Drag or use arrow keys"
        disabled={order.saving} onPointerDown={event => order.start(event, account.id)}
        onPointerMove={order.update} onPointerUp={order.finish} onPointerCancel={order.cancel}
        onContextMenu={event => event.preventDefault()}
        onKeyDown={event => {
          const delta = ["ArrowLeft", "ArrowUp"].includes(event.key) ? -1 : ["ArrowRight", "ArrowDown"].includes(event.key) ? 1 : 0;
          if (!delta) return;
          event.preventDefault();
          const next = siblings[siblings.findIndex(a => a.id === account.id) + delta];
          if (next) void order.move(account.id, next.id);
        }}><GripVertical size={18} /></button>}
    </div>
  );
}
